// extracted by mini-css-extract-plugin
export default {"hidden":"ProfilePopup_hidden_f251z"};